import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
	isAppInsightsEnabled,
	trackPageView,
} from '../../services/telemetry/appInsights';

let lastTrackedRoute = '';

const buildRouteIdentifier = (pathname: string, search: string, hash: string): string =>
	`${pathname}${search}${hash}`;

function AppInsightsRouteTracker() {
	const location = useLocation();

	useEffect(() => {
		if (!isAppInsightsEnabled()) {
			return;
		}

		const route = buildRouteIdentifier(location.pathname, location.search, location.hash);

		if (route === lastTrackedRoute) {
			return;
		}

		lastTrackedRoute = route;

		trackPageView(route, `${window.location.origin}${route}`);
	}, [location.hash, location.pathname, location.search]);

	return null;
}

export default AppInsightsRouteTracker;
